import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsFindBy } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';
import { wsGetAll } from 'services/WService';
import moment from 'moment';

export default function ModalConfig(props) {
  const Config = props.model;
  const [dataChanging, setDataChanging] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [distributionStaffManagers, setDistributionStaffManagers] = useState([]);
  const [distributionStaffInventory, setDistributionStaffInventory] = useState([]);
  const [zones, setZones] = useState([]);
  const [dayWeek, setDayWeeks] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listDayWeeks() {
    let response = await wsGetAll('base/visit-week');
    if (response.success) setDayWeeks(response.data);
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listVehicles(zoneId) {
    let response = await wsFindBy("prog/vehicle", {base_zone_id: zoneId,});
    if (response.success) setVehicles(response.data);
  }

  async function listDistributionStaffManagers(zoneId) {
    let response = await wsFindBy('prog/distribution-staff', {
      base_zone_id: zoneId,
      base_employee_positon_id: 2
    });
    if (response.success) {
      setDistributionStaffManagers(response.data);
    }
  }

  async function listStaffInventory(zoneId) {
    let response = await wsFindBy('prog/distribution-staff', {
      base_zone_id: zoneId,
      base_employee_positon_id: 1
    });
    if (response.success) {
      setDistributionStaffInventory(response.data);
    }
  }

  useEffect(() => {
    if (Config.open) {
      listZones();
      listDayWeeks();
    }
  }, [Config.open]);

  console.log("DATA: ", Config);
  console.log("DATACHAING: ", dataChanging);

  useEffect(() => {
    if (dataChanging.base_zone_id) {
      listVehicles(dataChanging.base_zone_id);
    }
  }, [dataChanging.base_zone_id]);

  useEffect(() => {
    if (dataChanging.prog_vehicle_id) {
      listDistributionStaffManagers(dataChanging.base_zone_id);
      listStaffInventory(dataChanging.base_zone_id);
    }
  }, [dataChanging.prog_vehicle_id]);

  useEffect(() => {
    if (dayWeek.length > 0 && Config.base_visit_day_id) {
      handleChange("base_visit_day_id", String(Config.base_visit_day_id));
    }
  },[dayWeek]);

  useEffect(() => {
    if (zones.length > 0 && Config.vehicle?.base_zone_id) {
      handleChange("base_zone_id", String(Config.vehicle?.base_zone_id));
    }
  },[zones]);

  useEffect(() => {
    if (vehicles.length > 0 && Config.prog_vehicle_id) {
      handleChange("prog_vehicle_id", String(Config.prog_vehicle_id));
    }
  },[vehicles]);

  useEffect(() => {
    if (vehicles.length > 0 && Config.prog_vehicle_id) {
      handleChange("prog_vehicle_id", String(Config.prog_vehicle_id));
    }
  },[vehicles]);

  useEffect(() => {
    if (distributionStaffManagers.length > 0 && Config.prog_distribution_staff_id_manager) {
      handleChange("prog_distribution_staff_id_manager", String(Config.prog_distribution_staff_id_manager));
    }
  },[distributionStaffManagers]);

  useEffect(() => {
    if (distributionStaffInventory.length > 0 && Config.prog_distribution_staff_id_inventory_manager) {
      handleChange("prog_distribution_staff_id_inventory_manager", String(Config.prog_distribution_staff_id_inventory_manager));
    }
  },[distributionStaffInventory]);

  return (
    <Modal
      title="Nueva configuración de programación"
      model={Config}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="prog/program-config"
      state
      dataForce={{
        base_visit_day_id: dataChanging.base_visit_day_id,
        prog_vehicle_id: dataChanging.prog_vehicle_id,
        prog_distribution_staff_id_manager: dataChanging.prog_distribution_staff_id_manager,
        prog_distribution_staff_id_inventory_manager: dataChanging.prog_distribution_staff_id_inventory_manager
      }}
    >
      <Autocomplete
        options={dayWeek}
        getOptionLabel={(option) => option.description}
        renderInput={(params) => (
          <TextField {...params} label="Días Visita" margin="normal" />
        )}
        onChange={(e, item) => { handleChange('base_visit_day_id', item?.id); }}
        value={ dayWeek.find((day) => String(day.id) === String(dataChanging.base_visit_day_id)) || null }
      />
      <Autocomplete
        disableClearable
        options={zones}
        getOptionLabel={(item) => `${item.description}`}
        renderInput={(params) => (
          <TextField {...params} label="Zona" margin="normal" required />
        )}
        onChange={(e, item) => {
          handleChange('base_zone_id', item?.id);
          handleChange('prog_vehicle_id', null);
          handleChange('prog_distribution_staff_id_manager', null);
          setVehicles([]);
          setDistributionStaffManagers([]);}}
        value={ zones.find((zone) => String(zone.id) === String(dataChanging.base_zone_id)) || null }
      />
      <Autocomplete
        disableClearable
        options={vehicles}
        getOptionLabel={(item) => `${item.name} (Placa: ${item.code})`}
        renderInput={(params) => (
          <TextField {...params} label="Vehiculo" margin="normal" required />
        )}
        onChange={(e, item) => {
          handleChange('prog_vehicle_id', item?.id);
          handleChange('prog_distribution_staff_id_manager', item?.prog_distribution_staff_id_manager);}}
        value={ vehicles.find((vehiculo) => String(vehiculo.id) === String(dataChanging.prog_vehicle_id)) || null }
      />
      <Autocomplete
        disableClearable
        // disabled
        options={distributionStaffManagers}
        getOptionLabel={(item) => `${item.name} (Licencia: ${item.driver_license})`}
        renderInput={(params) => (
          <TextField {...params} label="Chofer" margin="normal" required />
        )}
        onChange={(e, item) => {handleChange('prog_distribution_staff_id_manager', item?.id);}}
        value={ distributionStaffManagers.find((chfr) => String(chfr.id) === String(dataChanging.prog_distribution_staff_id_manager)) || null }
      />
      <Autocomplete
        disableClearable
        options={distributionStaffInventory}
        getOptionLabel={(item) => `${item.name} (Dni: ${item.code})`}
        renderInput={(params) => (
          <TextField {...params} label="Encargado de mercaderia" margin="normal" required />
        )}
        onChange={(e, item) => {handleChange('prog_distribution_staff_id_inventory_manager', item?.id);}}
        value={ distributionStaffInventory.find((chfr) => String(chfr.id) === String(dataChanging.prog_distribution_staff_id_inventory_manager)) || null }
      />
    </Modal>
  );
}
